import { render, staticRenderFns } from "./report-totals-settings.vue?vue&type=template&id=9c9e8aba&scoped=true&"
import script from "./report-totals-settings.vue?vue&type=script&lang=ts&"
export * from "./report-totals-settings.vue?vue&type=script&lang=ts&"
import style0 from "./report-totals-settings.vue?vue&type=style&index=0&id=9c9e8aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9e8aba",
  null
  
)

export default component.exports